import type { Network } from '@vaultsfyi/common/types'

interface CctpTiming {
  fastTransfer: {
    blocks: string
    estimatedTime: string
  }
  standardTransfer: {
    blocks: string
    estimatedTime: string
  }
}

const CCTP_TIMING: Partial<Record<Network, CctpTiming>> = {
  mainnet: {
    fastTransfer: {
      blocks: '2',
      estimatedTime: '~20 seconds',
    },
    standardTransfer: {
      blocks: '~65',
      estimatedTime: '~15-19 minutes',
    },
  },
  arbitrum: {
    fastTransfer: {
      blocks: '1',
      estimatedTime: '~8 seconds',
    },
    standardTransfer: {
      blocks: '~65',
      estimatedTime: '~15-19 minutes',
    },
  },
  optimism: {
    fastTransfer: {
      blocks: '1',
      estimatedTime: '~8 seconds',
    },
    standardTransfer: {
      blocks: '~65',
      estimatedTime: '~15-19 minutes',
    },
  },
  polygon: {
    fastTransfer: {
      blocks: '2-3',
      estimatedTime: '~8 seconds',
    },
    standardTransfer: {
      blocks: '2-3',
      estimatedTime: '~8 seconds',
    },
  },
  base: {
    fastTransfer: {
      blocks: '1',
      estimatedTime: '~8 seconds',
    },
    standardTransfer: {
      blocks: '~65',
      estimatedTime: '~15-19 minutes',
    },
  },
  avalanche: {
    fastTransfer: {
      blocks: '1',
      estimatedTime: '~8 seconds',
    },
    standardTransfer: {
      blocks: '1',
      estimatedTime: '~8 seconds',
    },
  },
  linea: {
    fastTransfer: {
      blocks: '1',
      estimatedTime: '~8 seconds',
    },
    standardTransfer: {
      blocks: '1',
      estimatedTime: '~6-32 hours',
    },
  },
  hyperliquid: {
    fastTransfer: {
      blocks: '1',
      estimatedTime: '~5 seconds',
    },
    standardTransfer: {
      blocks: '1',
      estimatedTime: '~5 seconds',
    },
  },
  unichain: {
    fastTransfer: {
      blocks: '1',
      estimatedTime: '~8 seconds',
    },
    standardTransfer: {
      blocks: '~65',
      estimatedTime: '~15-19 minutes',
    },
  },
  worldchain: {
    fastTransfer: {
      blocks: '1',
      estimatedTime: '~8 seconds',
    },
    standardTransfer: {
      blocks: '~65',
      estimatedTime: '~15-19 minutes',
    },
  },
  ink: {
    fastTransfer: {
      blocks: '1',
      estimatedTime: '~8 seconds',
    },
    standardTransfer: {
      blocks: '~65',
      estimatedTime: '~30 minutes',
    },
  },
  monad: {
    fastTransfer: {
      blocks: '1',
      estimatedTime: '~5 seconds',
    },
    standardTransfer: {
      blocks: '1',
      estimatedTime: '~5 seconds',
    },
  },
}

export function getCctpTiming(fromChain: Network, _toChain: Network, transferType: 'fast' | 'standard') {
  const sourceTiming = CCTP_TIMING[fromChain]

  if (!sourceTiming) {
    return transferType === 'fast'
      ? { blocks: '1', estimatedTime: '~8-20 seconds' }
      : { blocks: '~65', estimatedTime: '~15-19 minutes' }
  }

  return transferType === 'fast' ? sourceTiming.fastTransfer : sourceTiming.standardTransfer
}
